import { client } from '../utils/http';

export interface SignupRequest {
  firstName: string,
  lastName: string,
  email: string,
  enableMarketingEmails: boolean,
  challengeTag: string,
}
export async function signupToChallenges({ firstName, lastName, email, enableMarketingEmails, challengeTag }: SignupRequest) {
  const response = await client.post('/api/signup-challenges-auth/signup', {
    firstName,
    lastName,
    email,
    enableMarketingEmails,
    challengeTag,
  });
  return response.data;
}
